import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit {
  @Input() showCard: boolean = true;
  /** When set, parent controls open state (e.g. for accordion – only one open at a time) */
  @Input() isExpanded?: boolean;
  @Output() toggle = new EventEmitter<void>();

  showTermsAndConditions: boolean = false;

  get expanded(): boolean {
    return this.isExpanded !== undefined ? this.isExpanded : this.showTermsAndConditions;
  }

  constructor() {}

  ngOnInit() {}

  toggleTermsAndConditions(): void {
    if (this.isExpanded !== undefined) {
      this.toggle.emit();
    } else {
      this.showTermsAndConditions = !this.showTermsAndConditions;
    }
  }
}
